import React from "react";
import { object, string } from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
// eslint-disable-next-line import/no-cycle
import { BrandsCarousel } from "./BrandsCarousel";

const BrandsCarouselConnector = ({ data, locale }) => {
	const hotelsData = useStaticQuery(graphql`
		query HotelsQuery {
			allContentfulHotelChain {
				nodes {
					id
					node_locale
					title
					slug
					hotelChainPriority
					logo {
						secure_url
						width
						height
						raw_transformation
						version
						public_id
						format
					}
				}
			}
		}
	`);

	let hotels = hotelsData.allContentfulHotelChain.nodes;

	if (locale) {
		// eslint-disable-next-line func-names
		hotels = hotels.filter(function (e) {
			return e.node_locale === locale;
		});
	}

	const numSlides = Math.ceil(hotels.length / data.entriesPerPage);
	const slides = [];

	for (let i = 0; i < numSlides; i++) {
		const entries = hotels.slice(0, data.entriesPerPage);
		hotels = hotels.slice(data.entriesPerPage);

		slides.push(entries);
	}
	return <BrandsCarousel title={data.displayTitle} slides={slides} />;
};

BrandsCarouselConnector.propTypes = {
	data: object,
	locale: string,
};

BrandsCarouselConnector.defaultProps = {
	data: null,
	locale: null,
};

export default BrandsCarouselConnector;
export { BrandsCarouselConnector };
